import React, { useState } from "react";
import { useAuth } from "../../../hooks/auth";
import { Link } from "react-router-dom";
import {
  FormControlLabel,
  Box,
  Container,
  Typography,
  Grid,
  Button,
  TextField,
  CssBaseline,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Checkbox,
} from "@mui/material";

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <a style={{color: "#06d6d6"}} href="https://fortuneprecious.netlify.app">
        Bukafey
      </a>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

export const SignUp = () => {
  const { signup } = useAuth();
  const [gender, setGender] = useState("");
  const [cos, setCos] = useState("");
  const [hall, setHall] = useState("");
  const [level, setLevel] = useState("");
  const [mealoption, setMealOption] = useState("");
  const [semester, setSemester] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    console.log({
      email: data.get("email"),
      password: data.get("password"),
      role: 2,
      first_name: data.get("first_name"),
      last_name: data.get("last_name"),
      phone_no: data.get("phone_no"),
      matric_no: data.get("matric_no"),
      level: level,
      gender: gender,
      course_of_study: cos,
      hall: hall,
      meal_option: mealoption,
      semester: semester,
    });
    signup({
      email: data.get("email"),
      password: data.get("password"),
      role: 2,
      first_name: data.get("first_name"),
      last_name: data.get("last_name"),
      phone_no: data.get("phone_no"),
      matric_no: data.get("matric_no"),
      level: level,
      gender: gender,
      course_of_study: cos,
      hall: hall,
      meal_option: mealoption,
      semester: semester,
    });
  };

  const courses = [
    "History & International Studies",
    "English Studies",
    "French and International Relations",
    "Christian Religious Studies",
    "Music",
    "English Language",
    "Educational Planning & Administration",
    "Business Education",
    "Business Administration",
    "Accounting",
    "Agricultural Economics and Extension",
    "Animal Science",
    "Biochemistry",
    "Computer Science",
    "Finance",
    "Information Technology",
    "Mass Communication",
    "Microbiology",
    "Physics",
    "Physiology",
    "Political Science",
    "Software Engineering",
    "Economics",
    "Economics Education",
    "Guidance and Counseling",
    "Information Resources Management",
    "Nursing Science",
    "Agriculture in Agronomy and Landscape Design",
    "Laws",
    "Medical Laboratory Science",
    "Biology",
    "Marketing",
    "Social Work and Human Services",
    "Public Health",
    "Medicine",
  ].sort();

  const halls = [
    "Gideon Troopers",
    "Winslow",
    "Bethel Splendor",
    "Samuel Akande",
    "Felicia Adebisi Dada",
    "Queen Esther",
    "Platinum",
    "Ameyo Adadevoh",
    "Justice Deborah",
    "Neal Wilson",
    "Nelson Mandela",
    "Welch",
    "Havilah Gold",
    "Crystal",
    "Gamaliel",
    "White",
    "Nyberg",
    "Ogden",
    "Iperu Female",
  ].sort();
  const levels = [100, 200, 300, 400, 500, 600];
  const mealOptions = [
    {
      value: "B.L",
      text: "Breakfast & Lunch",
    },
    {
      value: "B.S",
      text: "Breakfast & Supper",
    },
    {
      value: "L.S",
      text: "Lunch & Supper",
    },
    {
      value: "B.L.S",
      text: "Breakfast, Lunch & Supper",
    },
  ];

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 3,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Box sx={{ m: 1 }}>
          <img
            src="/images/sign_up_icon_1.svg"
            alt="Login SVG"
            height="130px"
          />
        </Box>
        <Typography component="h1" variant="h5">
          Sign up
        </Typography>
        <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                autoComplete="given-name"
                name="first_name"
                required
                fullWidth
                id="first_name"
                label="First Name"
                autoFocus
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                required
                fullWidth
                id="last_name"
                label="Last Name"
                name="last_name"
                autoComplete="family-name"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                required
                fullWidth
                type="number"
                id="phone_no"
                label="Phone Number"
                name="phone_no"
                autoComplete="family-name"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="new-password"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                required
                fullWidth
                id="matric_no"
                label="Matric No"
                name="matric_no"
                autoComplete="family-name"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Semester</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={semester}
                  label="Level"
                  onChange={(e) => {
                    setSemester(e.target.value);
                  }}
                >
                  <MenuItem value={1}>{"1st"}</MenuItem>
                  <MenuItem value={2}>{"2nd"}</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Level</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={level}
                  label="Level"
                  onChange={(e) => {
                    setLevel(e.target.value);
                  }}
                >
                  {levels.map((value, index) => (
                    <MenuItem key={index} value={value}>
                      {value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Gender</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={gender}
                  label="Gender"
                  onChange={(e) => {
                    setGender(e.target.value);
                  }}
                >
                  <MenuItem value={"Male"}>Male</MenuItem>
                  <MenuItem value={"Female"}>Female</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Course Of Study
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={cos}
                  label="Course_of_study"
                  onChange={(e) => {
                    setCos(e.target.value);
                  }}
                >
                  {courses.map((value, index) => (
                    <MenuItem key={index} value={value}>
                      {value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Hall Of Residence
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={hall}
                  label="Hall_of_residence"
                  onChange={(e) => {
                    setHall(e.target.value);
                  }}
                >
                  {halls.map((value, index) => (
                    <MenuItem key={index} value={value}>
                      {value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Meal Option
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={mealoption}
                  label="Gender"
                  onChange={(e) => {
                    setMealOption(e.target.value);
                  }}
                >
                  {mealOptions.map((option, index) => (
                    <MenuItem key={index} value={option.value}>
                      {option.text}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={<Checkbox value="allowExtraEmails" color="primary" />}
                label="I want to receive inspiration and updates via email."
              />
            </Grid>
          </Grid>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{
              mt: 3,
              mb: 2,
              backgroundColor: "primary.main",
              color: "white",
            }}
          >
            Sign Up
          </Button>
          <Grid container justifyContent="flex-end">
            <Grid item>
              <Link style={{color: "#06d6d6"}} to="/login">
                <Typography variant="body2">Already have an account? Sign in</Typography>
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Copyright sx={{ mt: 4 }} />
    </Container>
  );
};
